import React from "react";
//#region types
import { MonthRangeSelectorBubbleProps } from "models/propTypes/datepickerPropTypes";
//#endregion
//#region components
import MonthRangePickerBase from "./monthRangePickerBase";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const MonthRangeSelectorBubble: React.FC<MonthRangeSelectorBubbleProps> = (props) => {
  return (
    <MonthRangePickerBase
      {...props}
      popperClassName="popperWithSelection"
      className={clsx(cssExports.datePickerBubble, props.className)}
      showBubble
    />
  );
};
export default MonthRangeSelectorBubble;
